module.exports = {"version":"1.0.0-beta.18","lerna":"2.0.0","packages":["packages/*"]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/web3/lerna.json
// module id = 468
// module chunks = 0